"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var getCurrentlySelectedBlock = function getCurrentlySelectedBlock(editorState) {
  var selection = editorState.getSelection(),
      startKey = selection.getStartKey(),
      endKey = selection.getEndKey(),
      content = editorState.getCurrentContent(),
      target = selection;

  if (startKey !== endKey && 0 === selection.getEndOffset()) {
    var blockBefore = content.getBlockBefore(endKey);
    blockBefore && (endKey = blockBefore.getKey(), target = target.merge({
      anchorKey: startKey,
      anchorOffset: selection.getStartOffset(),
      focusKey: endKey,
      focusOffset: blockBefore.getLength(),
      isBackward: !1
    }));
  }

  var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
    return k !== startKey;
  }).takeWhile(function (_, k) {
    return k !== endKey;
  }).some(function (v) {
    return "atomic" === v.getType();
  }),
      currentBlock = content.getBlockForKey(startKey);
  return {
    content: content,
    currentBlock: currentBlock,
    hasAtomicBlock: hasAtomicBlock,
    target: target
  };
},
    _default = getCurrentlySelectedBlock;

exports["default"] = _default;